import { classNames } from "@/react/helpers/twMergeWithCN";
import { useIsPropertiesPanelRevampEnabled } from "@circle-react-shared/BuilderUI/Hooks/useIsPropertiesPanelRevamp";
import { Form } from "@circle-react-uikit/Form";
import { useFormItem } from "../../DefaultEditorV2/useFormItem";

export interface BooleanFieldProps {
  isDisabled?: boolean;
  label: string;
  name: string;
  tooltipText?: string;
}

export const BooleanField = ({
  name,
  label,
  isDisabled,
  tooltipText,
}: BooleanFieldProps) => {
  const { getFormItemProps } = useFormItem();
  const isPropertiesPanelV2 = useIsPropertiesPanelRevampEnabled();

  if (isPropertiesPanelV2) {
    return (
      <Form.Item
        name={name}
        label={label}
        shouldToggleValueOnLabelClick
        isDisabled={isDisabled}
        tooltipText={tooltipText}
        {...getFormItemProps({
          // eslint-disable-next-line i18next/no-literal-string -- False positive
          className: classNames("!flex flex-row-reverse !items-center gap-2"),
          // eslint-disable-next-line i18next/no-literal-string -- False positive
          labelClassName: "text-sm text-dark",
        })}
      >
        <Form.ToggleSwitch
          name={name}
          variant="small"
          labelClassName="mb-0"
          disabled={isDisabled}
        />
      </Form.Item>
    );
  }

  return (
    <Form.Item
      name={name}
      label={label}
      shouldToggleValueOnLabelClick
      isDisabled={isDisabled}
      tooltipText={tooltipText}
      {...getFormItemProps({
        // eslint-disable-next-line i18next/no-literal-string -- False positive
        className: "!flex !items-center justify-between",
      })}
    >
      <Form.ToggleSwitch
        name={name}
        variant="small"
        labelClassName="mb-0"
        disabled={isDisabled}
      />
    </Form.Item>
  );
};
